export const isRTL = (language: any) => {
  const rtlLanguages = ["he", "ar"];
  return rtlLanguages.includes(language);
};

const baseURL = "nbafantasy.nba.com";
const scheme = "https://";
const frUrl = window.location.hostname.includes("lequipe")
  ? `${scheme}nbafantasy.lequipe.fr`
  : `${scheme}fr.${baseURL}`;

export interface LocaleOption {
  countryCode: string;
  title: string;
  url: string;
  i18nKey: string;
}

export const locales: LocaleOption[] = [
  {
    countryCode: "gb",
    title: "English (GB)",
    url: `${scheme}${baseURL}`,
    i18nKey: "footer.gb",
  },
  {
    countryCode: "us",
    title: "English (US)",
    url: `${scheme}en.${baseURL}`,
    i18nKey: "footer.us",
  },
  {
    countryCode: "de",
    title: "German",
    url: `${scheme}de.${baseURL}`,
    i18nKey: "footer.de",
  },
  {
    countryCode: "fr",
    title: "French",
    url: frUrl,
    i18nKey: "footer.fr",
  },
  {
    countryCode: "es",
    title: "Spanish",
    url: `${scheme}es.${baseURL}`,
    i18nKey: "footer.es",
  },
  {
    countryCode: "it",
    title: "Italian",
    url: `${scheme}it.${baseURL}`,
    i18nKey: "footer.it",
  },
  {
    countryCode: "gr",
    title: "Greek",
    url: `${scheme}gr.${baseURL}`,
    i18nKey: "footer.gr",
  },
  {
    countryCode: "tr",
    title: "Turkish",
    url: `${scheme}tr.${baseURL}`,
    i18nKey: "footer.tr",
  },
  {
    countryCode: "he",
    title: "Hebrew",
    url: `${scheme}nbafantasy.sport5.co.il`,
    i18nKey: "footer.he",
  },
  {
    countryCode: "br",
    title: "Portuguese (BR)",
    url: `${scheme}br.${baseURL}`,
    i18nKey: "footer.br",
  },
];
